import { Property } from '../../types/property';

const isHighlightedDevelopment = (property: Property) => {
  return !!(property.featuredListing && property.properties && property.properties.length > 0);
};

export default isHighlightedDevelopment;
